module.exports = __webpack_public_path__ + "4d9f4f2732a8a350a7dde8ec7de15590.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorSNACKS.jpg
// module id = 1041
// module chunks = 1